<div class="relative inline-block text-left" (clickOutside)="closeMenus()">
  <div>
    <button
      type="button"
      class="flex items-end h-10 w-13"
      (click)="toggleMainMenu(); $event.stopPropagation()"
      tabindex="0"
    >
      @if (profileImage()) {
        <img class="w-10 h-10 rounded-full" [src]="profileImage()" alt="Profile image" />
      } @else {
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:svg="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_10469_12771"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="25"
            height="24"
          >
            <rect x="0.5" width="24" height="24" fill="#ffffff" y="0" />
          </mask>
          <g
            mask="url(#mask0_10469_12771)"
            transform="matrix(1.7830508,0,0,1.7830508,-1.9576271,-1.5661017)"
            style="stroke-width: 0.560836"
          >
            <path
              d="M 6.05128,18.094 C 6.99572,17.4145 7.99786,16.8771 9.05769,16.4818 10.1175,16.0865 11.265,15.8889 12.5,15.8889 c 1.235,0 2.3825,0.1976 3.4423,0.5929 1.0598,0.3953 2.062,0.9327 3.0064,1.6122 0.7336,-0.7592 1.3237,-1.656 1.7703,-2.6902 C 21.1656,14.3696 21.3889,13.235 21.3889,12 21.3889,9.53704 20.5231,7.43982 18.7917,5.70833 17.0602,3.97685 14.963,3.11111 12.5,3.11111 10.037,3.11111 7.93982,3.97685 6.20833,5.70833 4.47685,7.43982 3.61111,9.53704 3.61111,12 c 0,1.235 0.22329,2.3696 0.66986,3.4038 0.4466,1.0342 1.0367,1.931 1.77031,2.6902 z m 6.44932,-5.5384 c -0.9363,0 -1.726,-0.3214 -2.3692,-0.9641 -0.64315,-0.6428 -0.96473,-1.4323 -0.96473,-2.36864 0,-0.93633 0.32136,-1.72607 0.96413,-2.36922 0.6427,-0.64317 1.4322,-0.96475 2.3686,-0.96475 0.9363,0 1.726,0.32137 2.3692,0.96411 0.6432,0.64272 0.9647,1.43225 0.9647,2.36858 0,0.93632 -0.3213,1.72612 -0.9641,2.36922 -0.6427,0.6432 -1.4322,0.9648 -2.3686,0.9648 z M 12.5,22 C 11.1054,22 9.79985,21.7404 8.58333,21.2212 7.36682,20.7019 6.30841,19.9922 5.40811,19.0919 4.50783,18.1916 3.79807,17.1332 3.27883,15.9167 2.75961,14.7001 2.5,13.3946 2.5,12 2.5,10.6054 2.75961,9.29985 3.27883,8.08333 3.79807,6.86682 4.50783,5.80841 5.40811,4.90811 6.30841,4.00783 7.36682,3.29807 8.58333,2.77883 9.79985,2.25961 11.1054,2 12.5,2 c 1.3946,0 2.7001,0.25961 3.9167,0.77883 1.2165,0.51924 2.2749,1.229 3.1752,2.12928 0.9003,0.9003 1.61,1.95871 2.1293,3.17522 C 22.2404,9.29985 22.5,10.6054 22.5,12 c 0,1.3946 -0.2596,2.7001 -0.7788,3.9167 -0.5193,1.2165 -1.229,2.2749 -2.1293,3.1752 -0.9003,0.9003 -1.9587,1.61 -3.1752,2.1293 C 15.2001,21.7404 13.8946,22 12.5,22 Z m 0,-1.1111 c 1.0242,0 2.0321,-0.1791 3.0235,-0.5374 0.9915,-0.3583 1.8483,-0.8486 2.5705,-1.4712 -0.7222,-0.5797 -1.5577,-1.0381 -2.5064,-1.375 C 14.6389,17.1684 13.6097,17 12.5,17 c -1.1097,0 -2.1424,0.1649 -3.09828,0.4947 -0.95585,0.3297 -1.78777,0.7916 -2.49575,1.3856 0.72222,0.6226 1.57907,1.1129 2.57053,1.4712 0.9914,0.3583 1.9993,0.5374 3.0235,0.5374 z m 0,-9.4445 c 0.6239,0 1.1503,-0.2143 1.5791,-0.6431 0.4287,-0.4288 0.6431,-0.95515 0.6431,-1.57908 0,-0.62392 -0.2144,-1.15028 -0.6431,-1.57905 C 13.6503,7.21439 13.1239,7 12.5,7 11.8761,7 11.3497,7.21439 10.9209,7.64317 10.4922,8.07194 10.2778,8.5983 10.2778,9.22222 c 0,0.62393 0.2144,1.15028 0.6431,1.57908 0.4288,0.4288 0.9552,0.6431 1.5791,0.6431 z"
              fill="currentColor"
              style="stroke-width: 0.314538"
            />
          </g>
        </svg>
      }
    </button>
  </div>

  @if (showMainMenu()) {
    <div
      @transformOpacityScale
      class="absolute right-0 z-10 mt-2 bg-white rounded-md shadow-lg min-w-32 ring-1 ring-black ring-opacity-5 focus:outline-none"
      role="menu"
      tabindex="-1"
    >
      @if (user()) {
        <div class="flex flex-col w-full px-4 py-2 border-b-2">
          @if (user()?.name) {
            <axpo-typography class="whitespace-nowrap">{{ user()?.name }}</axpo-typography>
          }
          <axpo-typography class="text-text-secondary" [variant]="'body-s'">
            {{ user()?.email }}
          </axpo-typography>
        </div>
      }
      <div class="py-1">
        @for (action of customActions(); track action; let index = $index) {
          <button
            class="flex items-center w-full px-4 py-2 text-sm text-left gap-x-2 whitespace-nowrap hover:cursor-pointer hover:bg-background-1"
            role="menuitem"
            (click)="clickOption(action, index); $event.stopPropagation()"
          >
            @if (action.icon === 'gear') {
              <svg
                version="1.1"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                stroke="currentColor"
                fill="none"
              >
                <path
                  d="m 20.919246,12.506351 c -0.28618,-0.193538 -0.28618,-0.580612 0,-0.774148 l 2.480218,-1.451529 C 23.59025,10.183906 23.685643,9.9903688 23.59025,9.7968327 23.49486,9.2162214 23.30407,8.6356102 23.208678,8.1517677 23.113288,7.9582308 23.017891,7.8614621 22.827106,7.8614621 l -2.861791,0.096769 c -0.381572,0 -0.572358,-0.3870744 -0.381572,-0.67738 l 1.526289,-2.5159807 c 0.09539,-0.1935373 0.09539,-0.3870746 0,-0.4838428 C 20.72846,3.8939538 20.346887,3.410111 19.965315,3.1198054 c -0.190785,-0.096768 -0.381572,-0.096768 -0.476965,0 l -2.480218,1.548296 c -0.286179,0.1935373 -0.667751,0 -0.667751,-0.3870738 l 0.09539,-2.9998239 c 0,-0.193537 -0.09539,-0.38707403 -0.286178,-0.38707403 -0.476966,-0.19353697 -1.049324,-0.29030554 -1.621681,-0.48384253 -0.190787,0 -0.381572,0.0967685 -0.476966,0.19353699 L 12.620055,3.2165733 c -0.190787,0.2903056 -0.572359,0.2903056 -0.763144,0 L 10.426015,0.60382383 C 10.330623,0.41028684 10.139836,0.31351827 9.9490507,0.41028684 9.3766922,0.50705533 8.8997273,0.7005924 8.3273694,0.79736089 8.1365828,0.89412937 8.0411905,0.99089793 8.0411905,1.1844349 l 0.095392,2.9998242 c 0,0.3870737 -0.3815719,0.580611 -0.6677508,0.3870737 L 4.6070428,2.9262678 c -0.1907864,-0.096768 -0.3815727,-0.096768 -0.4769655,0 C 3.7485054,3.3133424 3.3669336,3.7004162 2.9853617,4.08749 c -0.095394,0.1935373 -0.095394,0.3870746 0,0.4838428 l 1.5262875,2.6127499 c 0.1907864,0.2903057 0,0.6773794 -0.3815719,0.6773794 L 1.1728943,7.764694 c -0.19078603,0 -0.38157207,0.096768 -0.38157207,0.2903056 -0.19078603,0.4838418 -0.286179,1.0644531 -0.38157205,1.5482955 0,0.1935376 0.0953931,0.3870737 0.19078602,0.4838429 l 2.575611,1.451528 c 0.2861791,0.193537 0.2861791,0.580611 0,0.774147 l -2.575611,1.451528 c -0.19078602,0.09677 -0.28617892,0.290306 -0.19078602,0.483843 0.0953931,0.580611 0.28617907,1.064454 0.47696512,1.645065 0.095393,0.193537 0.190786,0.290305 0.381572,0.290305 l 2.9571828,-0.09677 c 0.3815727,0 0.5723582,0.387074 0.3815727,0.67738 l -1.5262884,2.612749 c -0.095393,0.193537 -0.095393,0.387074 0,0.483842 0.3815719,0.387074 0.7631438,0.774149 1.1447157,1.161223 0.1907863,0.09677 0.3815727,0.09677 0.4769655,0 l 2.5756111,-1.548296 c 0.2861782,-0.193538 0.6677508,0 0.6677508,0.387073 l -0.095394,2.999824 c 0,0.193538 0.095394,0.387074 0.2861789,0.387074 0.4769656,0.193537 1.0493227,0.290306 1.6216813,0.387075 0.1907866,0 0.3815723,-0.09677 0.4769663,-0.193538 l 1.430894,-2.61275 c 0.190787,-0.290305 0.572359,-0.290305 0.763144,0 l 1.430895,2.515982 c 0.09539,0.193537 0.286179,0.290306 0.476965,0.193537 0.572358,-0.09677 1.144717,-0.290306 1.621682,-0.483842 0.190786,-0.09677 0.286179,-0.193538 0.286179,-0.387074 v -2.903056 c 0,-0.387074 0.381571,-0.580611 0.66775,-0.387074 l 2.480218,1.548296 c 0.190786,0.09677 0.381573,0.09677 0.476965,0 0.381572,-0.387074 0.858538,-0.774148 1.144716,-1.257991 0.09539,-0.193536 0.09539,-0.387074 0,-0.483842 L 19.48835,16.957702 c -0.190786,-0.290306 0,-0.67738 0.381572,-0.67738 h 2.861791 c 0.190785,0 0.381572,-0.09677 0.381572,-0.290305 0.190785,-0.580611 0.286179,-1.064454 0.476965,-1.645065 0,-0.193536 -0.09539,-0.387074 -0.190786,-0.483842 z"
                />
                <path
                  d="m 16.912739,8.5388414 c 0.667751,0.9676857 1.144716,2.2256766 1.144716,3.5804356 0,3.386897 -2.671004,6.096415 -6.009759,6.096415 -3.3387547,0 -6.0097583,-2.709518 -6.0097583,-6.096415 0,-3.3868987 2.6710036,-6.0964167 6.0097583,-6.0964167 1.24011,0 2.384825,0.3870737 3.338755,0.967685"
                />
              </svg>
            } @else if (action.icon === 'user') {
              <svg
                version="1.1"
                viewBox="0 0 24 24"
                class="w-4 h-4"
                xmlns="http://www.w3.org/2000/svg"
                stroke="currentColor"
              >
                <g id="g9" transform="matrix(0.8872356,0,0,0.88725226,-8.5237293,-8.8058054)">
                  <path
                    d="m 23.200195,21.075195 c 3.074219,0 5.575196,-2.500976 5.575196,-5.575195 0,-3.074219 -2.500977,-5.5751953 -5.575196,-5.5751953 -3.074218,0 -5.575195,2.5009763 -5.575195,5.5751953 0,3.074219 2.500977,5.575195 5.575195,5.575195 z m 0,-10.40039 c 2.660156,0 4.825196,2.164551 4.825196,4.825195 0,2.660644 -2.16504,4.825195 -4.825196,4.825195 -2.660644,0 -4.825195,-2.164551 -4.825195,-4.825195 0,-2.660644 2.164551,-4.825195 4.825195,-4.825195 z"
                  />
                  <path
                    d="m 23.100098,23.125 c -5.886231,0 -10.675293,4.789062 -10.675293,10.674805 v 2.799804 c 0,0.207032 0.167969,0.375 0.375,0.375 h 3.600097 c 0.207032,0 0.375,-0.167968 0.375,-0.375 0,-0.207031 -0.167968,-0.375 -0.375,-0.375 h -3.225097 v -2.424804 c 0,-5.472657 4.452636,-9.924805 9.925293,-9.924805 5.473144,0 9.925293,4.452148 9.925293,9.924805 v 2.424804 H 19.700195 c -0.207031,0 -0.375,0.167969 -0.375,0.375 0,0.207032 0.167969,0.375 0.375,0.375 h 13.700196 c 0.207031,0 0.375,-0.167968 0.375,-0.375 V 33.799805 C 33.775391,27.914062 28.986328,23.125 23.100098,23.125 Z"
                  />
                </g>
              </svg>
            } @else if (action.icon === 'house') {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="w-4 h-4"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"
                />
              </svg>
            }
            <span class="text-text-primary">
              {{ action.label }}
            </span>
            @if (action.suboptions) {
              <ng-container [ngTemplateOutlet]="caret" />
            }
          </button>

          @if (showSubMenu() === index && action.suboptions) {
            <axpo-profile-submenu
              [items]="action.suboptions"
              (onItemSelected)="clickSuboption(action.value, $event)"
            />
          }
        }
        @if (availableLanguages() && availableLanguages().length > 0) {
          <button
            class="flex items-center w-full px-4 py-2 text-sm text-left gap-x-2 whitespace-nowrap hover:cursor-pointer hover:bg-background-1"
            role="menuitem"
            (click)="toggleLanuageMenu(); $event.stopPropagation()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="w-4 h-4"
              viewBox="0 0 16 16"
            >
              <path
                d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z"
              />
              <path
                d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31"
              />
            </svg>
            <span class="text-text-primary">{{ selectedLanguageLabel() }}</span>
            <ng-container [ngTemplateOutlet]="caret" />
          </button>
          @if (showLanguageMenu()) {
            <axpo-profile-submenu
              [items]="availableLanguages()"
              (onItemSelected)="clickLanguage($event)"
            />
          }
        }
        @if (showLogout()) {
          <button
            class="flex w-full gap-2 px-4 py-2 text-sm text-left whitespace-nowrap hover:cursor-pointer hover:bg-background-1"
            role="menuitem"
            (click)="selectLogout(); $event.stopPropagation()"
          >
            <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4">
              <path
                d="M5.57619 21C5.05841 21 4.62607 20.8266 4.2792 20.4797C3.93232 20.1328 3.75888 19.7005 3.75888 19.1827V4.8173C3.75888 4.29952 3.93232 3.86719 4.2792 3.52031C4.62607 3.17344 5.05841 3 5.57619 3H12.2181C12.3782 3 12.5119 3.05373 12.6194 3.16118C12.7268 3.26862 12.7806 3.40239 12.7806 3.5625C12.7806 3.72259 12.7268 3.85636 12.6194 3.96382C12.5119 4.07127 12.3782 4.125 12.2181 4.125H5.57619C5.40313 4.125 5.24447 4.19711 5.10023 4.34134C4.956 4.48558 4.88389 4.64423 4.88389 4.8173V19.1827C4.88389 19.3558 4.956 19.5144 5.10023 19.6587C5.24447 19.8029 5.40313 19.875 5.57619 19.875H12.2181C12.3782 19.875 12.5119 19.9287 12.6194 20.0362C12.7268 20.1436 12.7806 20.2774 12.7806 20.4375C12.7806 20.5976 12.7268 20.7314 12.6194 20.8388C12.5119 20.9463 12.3782 21 12.2181 21H5.57619ZM19.576 12.5625H10.1628C10.0027 12.5625 9.8689 12.5088 9.76145 12.4013C9.65399 12.2939 9.60026 12.1601 9.60026 12C9.60026 11.8399 9.65399 11.7061 9.76145 11.5987C9.8689 11.4912 10.0027 11.4375 10.1628 11.4375H19.576L17.3585 9.21996C17.2532 9.11466 17.197 8.98773 17.1897 8.83917C17.1825 8.69062 17.2388 8.55432 17.3585 8.43029C17.4782 8.30624 17.6109 8.24314 17.7566 8.24098C17.9022 8.23881 18.0371 8.29974 18.1612 8.42379L21.1013 11.364C21.2831 11.5457 21.3739 11.7577 21.3739 12C21.3739 12.2423 21.2831 12.4543 21.1013 12.636L18.1612 15.5762C18.0515 15.6858 17.9214 15.7432 17.7706 15.7482C17.6199 15.7533 17.4825 15.6938 17.3585 15.5697C17.2388 15.4457 17.18 15.3119 17.1822 15.1684C17.1843 15.0249 17.2453 14.8933 17.365 14.7735L19.576 12.5625Z"
                fill="currentColor"
              />
            </svg>
            <span class="text-text-primary">Logout</span>
          </button>
        }
      </div>
    </div>
  }
</div>

<ng-template #caret>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
  >
    <path
      d="M11.1358 3.44783C11.1358 3.44783 6.23656 8.58726 6.02654 8.58726C5.81653 8.58726 0.864246 3.41284 0.864246 3.41284"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</ng-template>
